import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const productInitialValues = {
  name: "",
  img: null,
  description: "",
  reference: "",
  amount: 1,
  price: 0,
  cost: 0,
  currency: "EUR",
  supplier: "",
  link: "",
  codePromotional: "",
  category: "",
  categoryId: undefined,
};

export const productValidationSchema = Yup.object({
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  img: Yup.mixed().required(FIELD_REQUIRED_MESSAGE),
  description: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  amount: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  price: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  currency: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  cost: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  category: Yup.string().nullable(),
  categoryId: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null ? undefined : value
    ),
}).test(
  "category-or-id",
  "Debes completar categoría o categoría ID",
  function (value) {
    const { category, categoryId } = value || {};
    const hasCategory = category && category.trim() !== "";
    const hasCategoryId = categoryId !== undefined && categoryId !== null;

    return hasCategory || hasCategoryId;
  }
);

export type ProductValues = typeof productInitialValues;
